{
  "airgap_violation": {
    "content": "<p>Abacus is geblokkeerd omdat de applicatie is verbonden met het internet.</p><ul><li>Wijzigingen zijn niet mogelijk</li><li>Alle werkplekken zijn vergrendeld</li></ul><h3>Wat te doen?</h3><ol><li>Verbreek de internetverbinding</li><li>Wacht 30 seconden</li><li><reload>Herlaad de pagina</reload></li></ol><p>Pas daarna kan Abacus weer gebruikt worden.</p>",
    "reload": "Probeer opnieuw",
    "title": "Abacus zit op slot"
  },
  "api_error": {
    "AirgapViolation": "Abacus is niet beschikbaar omdat de applicatie verbonden is met het internet. Abacus is alleen bedoeld voor offline gebruik.",
    "AlreadyInitialised": "De applicatie is al geconfigureerd. Je kan geen nieuwe beheerder aanmaken.",
    "ApportionmentNotCompleted": "De documenten kunnen pas gedownload worden als de zetelverdeling is afgerond",
    "ApportionmentCommitteeSessionNotCompleted": "De zetelverdeling kan pas gemaakt worden als de zitting is afgerond",
    "ApportionmentInvalidLotDrawing": "Loting is ongeldig",
    "BackupAlreadyExists": "De back-up met deze naam bestaat al, probeer het later opnieuw",
    "CertificateAlreadyAdded": "Deze publieke sleutel is al toegevoegd",
    "CertificateUnknownSubCommittee": "De publieke sleutel hoort bij een GSB dat niet bij deze verkiezing hoort",
    "CertificateWrongElection": "De publieke sleutel hoort bij een andere verkiezing",
    "CommitteeSessionPaused": "De coördinator heeft het invoeren van stemmen gepauzeerd. Je kan niet meer verder.",
    "DatabaseError": "Er is een fout opgetreden bij het opslaan van de invoer",
    "DataEntryAlreadyClaimed": "Een andere invoerder is bezig met dit stembureau",
    "DataEntryAlreadyFinalised": "De invoer voor dit stembureau is al gedaan",
    "DataEntryAlreadyImported": "De invoer voor dit stembureau is al geïmporteerd",
    "DataEntryCannotBeReset": "De invoer kan niet verwijderd worden",
    "DataEntryGetNotAllowed": "De status van de invoer staat deze actie niet toe",
    "DataEntryNotAllowed": "De invoer voor dit stembureau is niet toegestaan",
    "DataEntryValidationErrors": "Er zijn fouten opgetreden bij het valideren van het stembureau",
    "InvalidDataEntrySource": "De bron van de invoer is ongeldig",
    "ElectionMismatch": "Het EML-bestand hoort niet bij deze verkiezing",
    "EmlImportError": "Het EML-bestand is niet geldig",
    "EmlError": "Er is een fout opgetreden bij het verwerken van het EML-bestand",
    "EntryNotFound": "Niet gevonden",
    "EntryNotUnique": "Deze invoer bestaat al",
    "Forbidden": "Je hebt niet de juiste rechten",
    "InternalServerError": "Er is een interne fout opgetreden",
    "InvalidApportionmentState": "De zetelverdeling is niet in de juiste status voor deze actie",
    "InvalidCertificate": "Het bestand dat je probeert te importeren is geen publieke sleutel. Probeer een ander bestand.",
    "InvalidCommitteeSessionStatus": "De zitting is niet in de juiste status voor deze actie",
    "InvalidData": "De invoer is niet geldig",
    "InvalidCountType": "Het type telling is ongeldig",
    "InvalidDistrict": "De kieskring in het EML-bestand correspondeert niet met de kieskring van het gekozen stembureau",
    "InvalidFullname": "Volledige naam bevat ongeldige tekens",
    "InvalidHash": "De hash is niet geldig",
    "InvalidJson": "De JSON is niet geldig",
    "InvalidPassword": "Het opgegeven wachtwoord is onjuist",
    "InvalidPoliticalGroup": "De politieke partij is niet geldig",
    "InvalidSession": "De sessie is ongeldig",
    "InvalidStateTransition": "Er is een ongeldige actie uitgevoerd",
    "InvalidUsername": "Gebruikersnaam bevat ongeldige tekens",
    "InvalidUsernameOrPassword": "De gebruikersnaam of het wachtwoord is onjuist",
    "InvalidVoteCandidate": "De kandidaat van de stem is niet geldig",
    "InvalidVoteGroup": "De politieke partij van de stem is niet geldig",
    "InvestigationHasDataEntryOrResult": "Er zijn al gecorrigeerde telresultaten ingevoerd",
    "InvestigationRequiresCorrectedResults": "Er zijn gecorrigeerde telresultaten vereist voor dit onderzoek",
    "LoginRateLimited": "Te veel inlogpogingen. Wacht even voordat je opnieuw probeert in te loggen.",
    "NotInitialised": "De applicatie is nog niet klaar voor gebruik.",
    "OwnAccountCannotBeDeleted": "Je kunt je eigen account niet verwijderen",
    "PasswordRejectionSameAsOld": "Het opgegeven wachtwoord voldoet niet aan de eisen. Het nieuwe wachtwoord mag niet gelijk zijn aan het oude wachtwoord.",
    "PasswordRejectionSameAsUsername": "Het opgegeven wachtwoord voldoet niet aan de eisen. Het wachtwoord mag niet gelijk zijn aan de gebruikersnaam.",
    "PasswordRejectionTooShort": "Het opgegeven wachtwoord voldoet niet aan de eisen. Het wachtwoord moet minimaal 13 karakters lang zijn.",
    "PdfGenerationError": "Er is een fout opgetreden bij het genereren van de PDF",
    "PollingStationRepeated": "Het stembureau is al ingevoerd",
    "RequestPayloadTooLarge": "Het bestand is groter dan toegestaan",
    "SignatureMissing": "Digitale handtekening ontbreekt",
    "SignatureUnknown": "Onbekende digitale handtekening",
    "SubCommitteeHasNoCertificates": "Er zijn geen publieke sleutels geïmporteerd voor dit GSB",
    "Unauthorized": "Je bent niet ingelogd of je sessie is verlopen",
    "UnknownCommittee": "Onbekend stembureau",
    "UsernameNotUnique": "De gebruikersnaam is al in gebruik",
    "UserNotFound": "De gebruiker is niet gevonden",
    "ZipError": "Er is een fout opgetreden bij het verwerken van het ZIP-bestand"
  },
  "committee_session_not_found": "Zitting niet gevonden",
  "data_entry_not_found": "Het invoernummer is ongeldig",
  "election_not_found": "Verkiezing niet gevonden",
  "elections_not_found": "Verkiezingen niet gevonden",
  "forbidden": "Geen toegang",
  "forbidden_message": "Je probeert iets te doen dat (nu) niet mag of kan. Ga terug en probeer het eventueel opnieuw. Kom je er niet uit? Overleg met de coördinator of beheerder.",
  "instruction": {
    "content": "Neem contact op met de ontwikkelaars of rapporteer een bug via <link>https://github.com/kiesraad/abacus</link>",
    "title": "Komt het probleem terug?"
  },
  "label": "Fout",
  "network_error": "<p>Er kan geen verbinding worden gemaakt met de Abacus-server.</p><p>Zorg dat Abacus bereikbaar is en probeer het opnieuw.</p><p>Foutmelding:</p><pre>{error}</pre>",
  "not_found": "Pagina niet gevonden",
  "not_found_feedback": "We kunnen de pagina die je zoekt niet vinden. Het kan zijn dat de pagina is verplaatst of verwijderd.",
  "not_possible": "Dit kan nu niet",
  "page_not_found": "De pagina <code>{path}</code> is niet gevonden.",
  "title": "Abacus is stuk"
}
